import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"left","margin-right":"10px"} }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { style: {"text-align":"right","margin-right":"10px"} }
const _hoisted_4 = { style: {"display":"inline-flex","vertical-align":"middle"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_tab = _resolveComponent("tab")!
  const _component_AppContent = _resolveComponent("AppContent")!

  return (_openBlock(), _createBlock(_component_AppContent, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.totalingScreenNames), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_avatar, {
          src: _ctx.userPicture,
          width: "30",
          style: {"display":"inline-flex","vertical-align":"middle"}
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.userEmail), 1)
      ]),
      _hoisted_5,
      _createElementVNode("div", null, [
        _createVNode(_component_tab)
      ]),
      _hoisted_6,
      _hoisted_7
    ]),
    _: 1
  }))
}